import React from "react";

const DownloadLink = ({ fileUrl, fileName }) => {
  return (
    <a href={fileUrl} download={fileName}>
      Download {fileName}
    </a>
  );
};

export default DownloadLink;
